<template>
  <div class="submenu">
    <div class="submenuTitle">
      <span :contenteditable="submenuEdit" v-on:click.stop="renameSubmenu"
        ref="submenu" v-on:focus="submenuFocused"
        v-on:keydown="submenuKeydown"
        v-on:blur="saveSubmenuMenu">
        {{submenu.title[lang]}}
      </span>
      <div class="menuAction">
        <div class="actionItem unpublished"
          v-if="submenu.status === 'unpublished'" v-on:click.stop="publishSubmenu">
          <div class="info">Publish</div>
        </div>
        <div class="actionItem published" v-else v-on:click.stop="unpublishSubmenu">
          <div class="info">Unpublish</div>
        </div>
        <div class="actionItem more" v-on:click.stop="submenuMore = true"
          :class="{open: submenuMore}">
          <div class="menuOverlay" v-if="submenuMore"
            v-on:click.stop="submenuMore = null"></div>
          <div class="actionMenu" v-if="submenuMore"
            v-on:click.stop="doNothing">
            <li v-on:click="editSubmenu">
              <div class="icon edit"></div> Edit</li>
            <div class="divider"></div>
            <li v-on:click="renameSubmenu">
              <div class="icon rename"></div> Rename</li>
            <li v-on:click="unpublishSubmenu" v-if="submenu.status === 'published'">
              <div class="icon unpublish"></div> Unpublish</li>
            <li v-on:click="publishSubmenu" v-else>
              <div class="icon publish"></div> Publish</li>
            <div class="divider"></div>
            <li class="red" v-on:click="deleteSubmenu">
              <div class="icon delete"></div> Delete Item</li>
          </div>
        </div>
      </div>
    </div>
    <div class="menuCnt">
      <draggable v-model="submenu.menus" v-on:change="$emit('saveMenu')" group="menu">
        <div class="menuItem" v-for="(m, i) in submenu.menus" :key="`sm${i}`"
          :class="{collapsed: m.collapsed, noSub: !m.submenus || m.submenus.length < 1}">
          <div class="menu" v-on:click="m.collapsed = !m.collapsed"
            :class="{unpublished: m.status === 'unpublished'}">
            <div class="menuName">
              <span :contenteditable="menuEdit" v-on:click.stop="rename(m, i)"
                :ref="`menu-name-${i}`" v-on:focus="nameFocused"
                v-on:keydown="nameKeydown"
                v-on:blur="saveMenu($event, m, i)">
                {{m.name[lang]}}
              </span>
            </div>
            <div class="menuInfo">
              {{m.type}}
              <template v-if="m.page"> - {{m.page.name[lang]}}</template>
              <template v-if="m.pages && m.pages.length > 0">
                - {{m.pages[0].name[lang]}}
                <template v-if="m.pages.length > 1">
                  +{{m.pages.length - 1}} more
                </template>
              </template>
              <template v-if="m.content"> - {{m.content.title[lang]}}</template>
              <template v-if="m.directory"> - {{m.directory.name[lang]}}</template>
              <template v-if="m.link"> - {{m.link}}</template>
            </div>
            <div class="menuAction">
              <div class="actionItem clicked">
                <template v-if="m.viewCount >= 1000000000">
                  {{Math.floor(m.viewCount/1000000000).toLocaleString('id')}}b
                </template>
                <template v-else-if="m.viewCount >= 1000000">
                  {{Math.floor(m.viewCount/1000000).toLocaleString('id')}}m
                </template>
                <template v-if="m.viewCount >= 1000">
                  {{Math.floor(m.viewCount/1000).toLocaleString('id')}}k
                </template>
                <template v-else-if="m.viewCount">
                  {{m.viewCount.toLocaleString('id')}}
                </template>
                <div class="info" v-if="m.viewCount">
                  Opened <b>{{m.viewCount.toLocaleString('id')}}</b>x
                </div>
              </div>
              <div class="actionItem unpublished"
                v-if="m.status === 'unpublished'" v-on:click.stop="publish(m, i)">
                <div class="info">Publish menu</div>
              </div>
              <div class="actionItem published" v-else v-on:click.stop="unpublish(m, i)">
                <div class="info">Unpublish menu</div>
              </div>
              <div class="actionItem more" v-on:click.stop="menuMore = i"
                :class="{open: menuMore === i}">
                <div class="menuOverlay" v-if="menuMore === i"
                  v-on:click.stop="menuMore = null"></div>
                <div class="actionMenu" v-if="menuMore === i"
                  v-on:click.stop="doNothing">
                  <li v-on:click="editMenu(m, i)">
                    <div class="icon edit"></div> Edit</li>
                  <div class="divider"></div>
                  <li v-on:click="$emit('openMenu', m, i); menuMore = null;">
                    <div class="icon link"></div> Open Menu</li>
                  <li v-on:click="rename(m, i)">
                    <div class="icon rename"></div> Rename</li>
                  <li v-on:click="unpublish(m, i)" v-if="m.status === 'published'">
                    <div class="icon unpublish"></div> Unpublish</li>
                  <li v-on:click="publish(m, i)" v-else>
                    <div class="icon publish"></div> Publish</li>
                  <div class="divider"></div>
                  <li class="red" v-on:click="deleteItem(m, i)">
                    <div class="icon delete"></div> Delete Item</li>
                </div>
              </div>
            </div>
          </div>
          <draggable v-if="m.submenus" group="submenu"
            v-model="m.submenus" v-on:change="doSaveMenu">
            <Submenu4 :submenu="submenu"
              v-for="(submenu, i2) in m.submenus" :key="`sm${i2}`"
              v-on:saveMenu="doSaveMenu" v-on:openMenu="openMenu"
              v-on:delete="deleteSubmenuItem(m, i2)"></Submenu4>
          </draggable>
          <div class="addMenuCnt addSubmenu4">
            <div class="menu addMenu" v-on:click="addSubmenu(m)">Submenu</div>
          </div>
        </div>
      </draggable>
      <div class="menuItem addMenuCnt addMenuItem">
        <div class="menu addMenu" v-on:click="addMenu">Menu Item</div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <AddMenu ref="addMenu"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import Submenu4 from '@/components/Submenu4.vue';
import Confirmation from '@/components/Confirmation.vue';
import AddMenu from '@/components/AddMenu.vue';

export default {
  components: {
    draggable,
    Submenu4,
    Confirmation,
    AddMenu,
  },
  props: ['submenu'],
  data() {
    return {
      menuEdit: null,
      menuMore: null,

      /**
       * Submenu edit
       *
       */
      submenuEdit: false,
      submenuMore: false,
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    doNothing() {},
    doSaveMenu() { this.$emit('saveMenu'); },
    openMenu(m, i) { this.$emit('openMenu', m, i); },

    /**
     * Rename
     *
     */
    nameFocused(e) {
      setTimeout(() => {
        let sel;
        let range;
        if (window.getSelection && document.createRange) {
          range = document.createRange();
          range.selectNodeContents(e.target);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(e.target);
          range.select();
        }
      });
    },
    nameKeydown(e) {
      if (e.code === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    },
    saveMenu(e, m, i) {
      setTimeout(() => {
        this.menuEdit = null;
        m.name[this.lang] = e.target.innerText; // eslint-disable-line
        this.doSaveMenu();
      });
    },

    /**
     * Action
     *
     */
    addMenu() {
      this.$refs.addMenu.open(null, (b, m) => {
        if (!b) return;
        this.submenu.menus.push(m);
        this.doSaveMenu();
      });
    },
    editMenu(item, i) {
      this.menuMore = null;
      this.$refs.addMenu.open(item, (b, m) => {
        if (!b) return;
        item.name = m.name; // eslint-disable-line
        item.descriptions = m.descriptions; // eslint-disable-line
        item.type = m.type; // eslint-disable-line
        item.page = m.page; // eslint-disable-line
        item.pages = m.pages; // eslint-disable-line
        item.content = m.content; // eslint-disable-line
        item.directory = m.directory; // eslint-disable-line
        item.link = m.link; // eslint-disable-line
        item.breadcrumb = m.breadcrumb; // eslint-disable-line
        this.doSaveMenu();
      });
    },
    editSubmenu() {
      this.submenuMore = false;
      this.$refs.confirmDialog.open({
        title: 'Edit Submenu',
        desc: 'Please input Submenu name',
        action: 'Save',
        inputs: [
          {
            type: 'text',
            label: 'Submenu name',
            value: { en: this.submenu.title.en, id: this.submenu.title.id },
          },
        ],
        multiLang: true,
      }, (b, c, d, v) => {
        if (!b) return;
        this.submenu.title = v[0].value;
        this.doSaveMenu();
      });
    },
    addSubmenu(m) {
      this.$refs.confirmDialog.open({
        title: 'Add Submenu',
        desc: 'Please input Submenu name',
        action: 'Save',
        inputs: [
          {
            type: 'text',
            label: 'Submenu name',
            value: { id: '', en: '' },
          },
        ],
        multiLang: true,
      }, (b, c, d, v) => {
        if (!b) return;
        m.collapsed = false; // eslint-disable-line
        if (!m.submenus) m.submenus = []; // eslint-disable-line
        m.submenus.push({
          title: v[0].value,
          status: 'published',
          menus: [],
        });
        this.doSaveMenu();
      });
    },
    unpublish(m, i) {
      this.menuMore = null;
      const name = m.name[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Unpublish ${name}`,
        desc: 'Unpublished item will not displayed in front-end',
        action: 'Unpublish',
      }, (b) => {
        if (!b) return;
        m.status = 'unpublished'; // eslint-disable-line
        this.doSaveMenu();
      });
    },
    publish(m, i) {
      this.menuMore = null;
      const name = m.name[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Publish ${name}`,
        desc: 'Published item will be displayed in the front-end',
        action: 'Publish',
      }, (b) => {
        if (!b) return;
        m.status = 'published'; // eslint-disable-line
        this.doSaveMenu();
      });
    },
    deleteItem(m, i) {
      this.menuMore = null;
      const name = m.name[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: 'Are you sure you want to delete this menu item?',
      }, (b) => {
        if (!b) return;
        this.submenu.menus.splice(i, 1);
        this.doSaveMenu();
      });
    },
    rename(m, i) {
      this.menuMore = null;
      this.menuEdit = i;
      setTimeout(() => {
        this.$refs[`menu-name-${i}`][0].focus();
      });
    },

    /**
     * Rename submenu
     *
     */
    saveSubmenuMenu(e) {
      this.submenu.title[this.lang] = e.target.innerText; // eslint-disable-line
      this.doSaveMenu();
    },
    submenuFocused(e) {
      setTimeout(() => {
        let sel;
        let range;
        if (window.getSelection && document.createRange) {
          range = document.createRange();
          range.selectNodeContents(e.target);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(e.target);
          range.select();
        }
      });
    },
    submenuKeydown(e) {
      if (e.code === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    },
    renameSubmenu() {
      this.submenuMore = false;
      this.submenuEdit = true;
      setTimeout(() => {
        this.$refs.submenu.focus();
      });
    },
    publishSubmenu() {
      this.submenuMore = null;
      const name = this.submenu.title[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Publish ${name}`,
        desc: 'Published item will be displayed in the front-end',
        action: 'Publish',
      }, (b) => {
        if (!b) return;
        this.submenu.status = 'published';
        this.doSaveMenu();
      });
    },
    unpublishSubmenu() {
      this.submenuMore = null;
      const name = this.submenu.title[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Unpublish ${name}`,
        desc: 'Unpublished item will not displayed in front-end',
        action: 'Unpublish',
      }, (b) => {
        if (!b) return;
        this.submenu.status = 'unpublished';
        this.doSaveMenu();
      });
    },
    deleteSubmenu() {
      this.submenuMore = false;
      this.$emit('delete');
    },
    deleteSubmenuItem(m, i) {
      const name = m.submenus[i].title[this.lang] || 'Submenu';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: 'Are you sure you want to delete this menu item?',
      }, (b) => {
        if (!b) return;
        m.submenus.splice(i, 1);
        this.doSaveMenu();
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
